module.exports = __webpack_public_path__ + "assets/img/box6_img1.9c0e26ca.png";